// extracted by mini-css-extract-plugin
export default {"menuContainer":"Menu_menuContainer__I330h","menuPage":"Menu_menuPage__7lxYz"};